import { Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DEFAULT_LANGUAGE, languages } from 'src/helpers/constants';
import { SignUpSuccessDataType } from 'src/types/authServiceEventTypes';

import { ApiService, Region } from '../api/api.service';

import { AuthService } from './auth.service';

const wasSupportedLocales = languages.map(({ code }) => code);

const resolveAuthServiceLocale = (lang: string | null): string =>
  lang && wasSupportedLocales.includes(lang) ? lang : DEFAULT_LANGUAGE;

@Component({
  selector: 'app-auth',
  imports: [],
  templateUrl: './auth.component.html',
})
export class AuthComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly apiService = inject(ApiService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authServiceAppId =
    this.apiService.region() === Region.EU ? environment.euAuthServiceAppId : environment.usAuthServiceAppId;
  private readonly authServiceLocale = resolveAuthServiceLocale(this.route.snapshot.paramMap.get('lang'));
  isLogout = this.route.snapshot.queryParamMap.get('logout') === 'true';
  authServiceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
    `${environment.authServiceDomain}/${this.authServiceLocale}` +
      `${this.isLogout ? '/logout' : ''}?appId=${this.authServiceAppId}`,
  );

  ngOnInit(): void {
    window.addEventListener('message', this.handleIframeEvent.bind(this), false);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.handleIframeEvent.bind(this), false);
  }

  handleIframeEvent({ origin, data }: MessageEvent<SignUpSuccessDataType>): void {
    if (origin === environment.authServiceDomain && data.eventName === 'signUpSuccess') {
      this.authService.getAccessToken(data.authorizationCode).subscribe(() => {});
    }
  }
}
